import {createSlice} from '@reduxjs/toolkit'

const initialState = {
    user: null,
    role: null,
    permissions: {},
    profilId: null,
}


const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUser: (state, action) => {
            state.user = action.payload
            state.role = action.payload.role
            state.profilId = action.payload.profilId || null
            state.permissions = action.payload.permissions || {}
        },
        clearUser: (state) => {
            state.user = null
            state.role = null
            state.profilId = null
            state.permissions = {}
        },
    },
})

export const {setUser, clearUser} = userSlice.actions
export default userSlice.reducer
